import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

import { RegularExpressions } from 'src/app/core/constants/regular-expressions';
import { TransferDataService } from 'src/app/core/services/transfer-data.service';
import { copyToClipboard } from 'src/app/core/utils/util';
import { MatchValidator } from 'src/app/core/validators/match-validator';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss'],
  standalone: false,
})
export class SetPasswordComponent
  extends BaseFormPageComponent
  implements OnInit
{
  @Input() formId: string = 'setPasswordForm';
  randomPassword: string;
  password: string;
  confirmPassword: string;
  hidePassword: boolean = true;

  @Input() responsiveClass: string = 'md:tw-w-full';
  @Input() addRowClass: boolean = true;
  @Input() passwordLabel: string = 'common.password';
  @Input() confirmPasswordLabel: string = 'common.rePassword';
  @Input() isRequired: boolean = true;
  @Input() isDisabledForm: boolean = false;
  @Input() isRefreshForm: boolean;
  @Input() showPasswordGenerator: boolean = true;

  @Output('password') output_password = new EventEmitter<string>();
  @Output('form') output_passwordForm = new EventEmitter<FormGroup>();
  @Output('isRefreshForm') output_isRefreshForm = new EventEmitter<boolean>();

  minLength: number = 8;
  maxLength: number = 32;
  userName: string = '';

  constructor() {
    super();
    this.userName = TransferDataService?.userName;
  }

  ngOnInit() {
    // this.getUserState();
    // if (!this.userName) this.userName = this.currentUserInfo?.userName;

    this.initForm();
    this.form.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((changes) => this.emitForm());
    if (this.isDisabledForm) this.form.disable();
  }

  initForm(): void {
    this.form = new FormGroup({
      password: new FormControl(
        '',
        this.isRequired ? [Validators.required] : []
      ),
      //define validators in onChangeConfirmPassword method
      confirmPassword: new FormControl(
        '',
        this.isRequired ? [Validators.required] : []
      ),
    });
  }

  ngOnChanges() {
    this.ngOnInit();
    this.emitRefreshForm();
  }

  onChangeConfirmPassword() {
    this.form.get('confirmPassword')?.clearValidators();
    if (!this.randomPassword && this.isRequired)
      this.form
        .get('confirmPassword')
        ?.setValidators([
          Validators.required,
          MatchValidator(this.password),
          Validators.minLength(this.minLength),
          Validators.maxLength(this.maxLength),
          Validators.pattern(RegularExpressions.securePassword),
        ]);
    this.form.get('confirmPassword')?.updateValueAndValidity();
  }

  onSetRandomPassword(randomPassword) {
    this.randomPassword = randomPassword;
    if (randomPassword) {
      this.password = randomPassword;
      this.confirmPassword = randomPassword;
      if (this.userName) {
        // Trigger native input events
        setTimeout(() => {
          if ('credentials' in navigator) {
            const cred = new (window as any).PasswordCredential({
              id: this.userName,
              password: randomPassword,
            });

            (navigator as any).credentials
              .store(cred)
              .then(() => console.log('Password stored'))
              .catch((err) =>
                console.warn('Credential API not supported', err)
              );
          }
        }, 100);
      }
      this.form.get('password')?.disable();
      this.form.get('confirmPassword')?.disable();

    } else {
      this.form.get('password')?.enable();
      this.form.get('confirmPassword')?.enable();
      this.onChangeConfirmPassword();
      this.password = '';
      this.confirmPassword = '';
    }
    this.form.get('password')?.updateValueAndValidity();
    this.form.get('confirmPassword')?.updateValueAndValidity();
    this.emitPassword();
  }

  onChangePassword() {
    this.emitPassword();
  }

  emitPassword() {
    this.output_password.emit(this.password);
  }

  emitForm() {
    this.output_passwordForm.emit(this.form);
  }

  emitRefreshForm() {
    this.output_isRefreshForm.emit(false);
  }

  copyToClipboard() {
    copyToClipboard(this.randomPassword);
  }
  
}
